import { Button, Dialog, Divider, LinearProgress, linearProgressClasses, Typography, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import React, { useEffect, useState } from 'react';
import { RxCross1 } from 'react-icons/rx';
import { useHistory } from 'react-router-dom';
import { getInstructions, getMeetings } from './Api';
import Loaders from '../../../GlobalComponents/KenLoader';
import AppLayout from '../Components/AppLayout';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { makeStyles, styled } from '@mui/styles';
import banner from '../Assets/banner-net.jpeg';
import net from '../Assets/netted.png';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import moment, { Moment } from 'moment';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import StartupTable from '../Components/StartupTable';
import gradient from '../Assets/gradient.png';
import { getFirstLetters } from '../Helpers/helper';
import routes from '../../../Utils/routes';
import storageService from '../../../Utils/storageService';

const useStyles = makeStyles(() => ({
  welcomCardName: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    '@media (max-width: 600px)': {
      fontSize: '16px !important',
      fontWeight: '500 !important',
    },
    '@media (max-width: 1440px)': {
      fontSize: '14px !important',
      fontWeight: '600 !important',
    },
  },
  teamEval: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
      fontWeight: '500 !important',
    },
  },
  welcomContainer: {
    height: '33vh',
    background: 'linear-gradient(90deg, #604797 0%, #805DC6 100%)',
    borderRadius: '12px',
    padding: '20px',
    '@media (max-width: 1440px)': {
      borderRadius: '16px',
      padding: '10px',
    },
  },
  welcomButton: {
    maxWidth: '164px',
    maxHeight: '36px',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    '@media (max-width: 600px)': {
      fontSize: '10px !important',
      fontWeight: '400 !important',
    },
    '@media (min-width: 1920px)': {
      maxWidth: '218px',
      maxHeight: '48px',
      fontSize: '16px !important',
    },
  },
  welcomeCardDescp: {
    fontSize: '14px !important',
    fontWeight: '400 !important',
    '@media (max-width: 600px)': {
      fontSize: '12px !important',
      fontWeight: '500 !important',
    },
    '@media (min-width: 1920px)': {
      fontSize: '18px !important',
      fontWeight: '400 !important',
    },
  },
  welcomeCardDescp2: {
    fontSize: '14px !important',
    fontWeight: '400 !important',
    '@media (max-width: 600px)': {
      fontSize: '12px !important',
      fontWeight: '400 !important',
    },
    '@media (min-width: 1920px)': {
      fontSize: '18px !important',
      fontWeight: '400 !important',
    },
  },
  meetingName: {
    fontSize: '12px !important',
    fontWeight: '600 !important',
    '@media (max-width: 600px)': {
      fontSize: '14px !important',
      fontWeight: '600 !important',
    },
  },
  meetingVenue: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    '@media (max-width: 600px)': {
      fontSize: '9px !important',
      fontWeight: '400 !important',
    },
  },
  meetingTime: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    '@media (max-width: 600px)': {
      fontSize: '8px !important',
      fontWeight: '500 !important',
    },
  },
  rootClasses: {
    background: '#fff',
    borderRadius: '6px',
    maxHeight: '100% !important',
    '@media (max-width: 1440px)': {
      '& .MuiDayCalendar-monthContainer': {
        height: '8rem !important', // Reduced height
        overflowY: 'scroll', // Enable scrolling
        scrollbarWidth: 'inherit !important', // For Firefox
        '&::-webkit-scrollbar': {
          width: '4px', // Scrollbar width
        },
      }
    },
    maxWidth: '100%',
    border: '1px solid #E6E6E6',
    fontFamily: '"General Sans", sans-serif',
    '& .MuiDateCalendar-root': {
      width: '100%',
    },
    '& .MuiPickersCalendarHeader-label': {
      fontSize: '10px', // Smaller font size
    },
    '& .MuiPickersCalendarHeader-root': {
      margin: '0px',
      padding: '4px 0px 4px 8px', // Reduced padding
      fontSize: '10px',
    },
    '& .MuiDayCalendar-weekContainer': {
      display: 'flex',
      gap: '0px',
      margin: '0px',
      padding: '0px',
    },
    '& .MuiDayCalendar-header': {
      display: 'flex',
      gap: '0px',
      margin: '0px',
    },
    '& .MuiTypography-root.MuiDayCalendar-weekDayLabel': {
      fontSize: '10px', // Smaller font size for weekdays
      fontWeight: '400',
    },
    '& .MuiPickersDay-root': {
      fontSize: '10px', // Smaller font size for day numbers
      padding: '4px', // Reduced padding for each day
    },
    '& .MuiDayCalendar-monthContainer': {
      height: '10rem', // Reduced height
      overflowY: 'scroll',
      scrollbarWidth: 'thin', // For Firefox
      '&::-webkit-scrollbar': {
        width: '4px', // Scrollbar width
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 0, 0, 0.3)', // Scrollbar color
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Hover effect
      },
    },
    '@media (min-width: 1920px)': {
      borderRadius: '6px', // Adjusted for larger screens
      maxHeight: '280px', // Adjusted max height
      '& .MuiDayCalendar-monthContainer': {
        height: '12rem !important', // Reduced height
        overflowY: 'scroll', // Enable scrolling
        scrollbarWidth: 'inherit !important', // For Firefox
        '&::-webkit-scrollbar': {
          width: '4px', // Scrollbar width
        },
      },
      '& .MuiDateCalendar-root': {
        width: '100%',
      },

      '& .MuiPickersCalendarHeader-label': {
        fontSize: '12px', // Larger font size for higher resolutions
      },
      '& .MuiPickersCalendarHeader-root': {
        margin: '4px 0px',
        padding: '0px 0px 0px 8px',
        fontSize: '12px',
      },
      '& .MuiDayCalendar-weekContainer': {
        display: 'flex',
        gap: '0px',
        margin: '0px',
        padding: '0px',
      },
      '& .MuiDayCalendar-header': {
        display: 'flex',
        gap: '0px',
        margin: '0px',
      },
      '& .MuiTypography-root.MuiDayCalendar-weekDayLabel': {
        fontSize: '12px',
        fontWeight: '400',
      },
    },
  },

  profileImage: {
    height: '108px',
    width: '108px',
    borderRadius: '12px',
    border: '1px solid #FFFFFF33',
    '@media (max-width: 600px)': {
      height: '72px',
      width: '72px',
    },
    '@media (min-width: 1920px)': {
      height: '144px',
      width: '144px',
    },
  },
  instructionTabBg: {
    height: '100%',
    objectFit: 'cover',
    width: '100%',
    position: 'absolute',
    borderRadius: '12px',
  },
  instructionCardTitle: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    '@media (min-width: 1920px)': {
      fontSize: '18px !important',
    },
  },
  instructionCardDescp: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
  instructionButton: {
    maxWidth: '90%',
    color: "#333333 !important",
    backgroundColor: "white !important",
    maxHeight: '36px',
    fontSize: '10px !important',
    fontWeight: '400',
    '@media (max-width: 1440px)': {
      maxWidth: '90%',
      maxHeight: '30px',
      fontSize: '10px !important',
      fontWeight: 100,
      color: "#333333 !important",
    },
    '@media (max-width: 600px)': {
      maxWidth: '111px',
      maxHeight: '28px',
      color: "#333333 !important",
      fontSize: '10px',
      fontWeight: '400',
    },
  },
  instructionTab: {
    height: '35vh',
    background: `url(${banner})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    position: 'relative',
    borderRadius: '12px',
    border: '1.1px solid #FFFFFF1A',
    '@media (max-width: 600px)': {
      height: '136px',
    },
  },
  assignedStartupHeader: {
    fontSize: '16px !important',
    marginBottom: 5,
    fontWeight: '500 !important',

    '@media (max-width: 1440px)': {
      fontSize: '14px !important',
    },
  },
  assignedStartupHeaderBtn: {
    textWrap: 'nowrap',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    '@media (min-width: 1920px)': {
      fontSize: '14px !important',
    },
  },
  scheduleSection: {
    border: '1px solid #F6F8FB',
    background: '#FFFFFF',
    borderRadius: '12px',
    padding: '12px',
    '@media (min-width: 1920px)': {
      borderRadius: '16px',
      padding: '18px',
    },
  },
  startupSection: {
    maxHeight: '280px',
    width: '100%',
    overflow: 'auto',
    gap: '8px',
  },
  startUpSectionContainer: {
    padding: '12px',
    borderRadius: '8px',
    borderLeft: '2px solid #604797',
    background: '#F5F1FF',
  },
  videoCamBg: {
    background: '#665097',
    height: '22px',
    width: '22px',
    borderRadius: '12px',
  },
  assignedStartupsection: {
    background: '#fff',
    height: '45vh',
    padding: '20px',
    marginTop:10,
    width: "81%",
    borderRadius: '12px',
    border: '1px solid #F6F8FB',
    '@media (max-width: 600px)': {
      padding: '0px',
    },
    '@media (max-width: 1440px)': {
      padding: '10px',
    },

  },
  instructionHead: {
    fontSize: '20px !important',
    fontWeight: '600 !important',
    color: '#6A4EA6 !important',
    '@media (max-width: 600px)': {
      fontSize: '14px !important',
      fontWeight: '500 !important',
      color: '#333333 !important',
    },
    '@media (min-width: 1920px)': {
      fontSize: '26px !important',
    },
  },
  instructionHeadContainer: {
    background: '#F7F4FF',
    padding: '40px',
    paddingBottom: '24px',
    borderBottom: '1px solid #ACACAC',
    '@media (max-width: 600px)': {
      padding: '16px',
      paddingBottom: '12px',
    },
  },
  instructionsHeading: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#545454',
    '@media (max-width: 600px)': {
      fontSize: '14px',
    },
    '@media (min-width: 1920px)': {
      fontSize: '21px',
    },
  },
  instructionsContext: {
    fontSize: '16px',
    fontWeight: '400',
    color: '#545454',
    '@media (max-width: 600px)': {
      fontSize: '12px',
    },
    '@media (min-width: 1920px)': {
      fontSize: '21px',
    },
  },
  scheduleTitle: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    '@media (min-width: 1920px)': {
      fontSize: '18px !important',
    },
  },
  scheduleTitleHead: {
    fontSize: '12px !important',
    fontWeight: '600 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
  scheduleVenue: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
  avatarText: {
    fontSize: '40px !important',
    fontWeight: '500 !important',
    color: '#604797 !important',
    '@media (max-width: 1440px)': {
      fontSize: '26px !important',
    },
  },
  avatarContainer: {
    background: '#F6F8FB',
    borderRadius: '12px',
    height: '90px',
    width: '90px',
    border: '1px solid #FFFFFF33',
    '@media (max-width: 1440px)': {
      height: '90px',
      width: '90px',
    },
  },
  scheduleDuration: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
}));

// Helper function to parse HTML instructions into structured object
const parseInstructions = (htmlString: string): any => {
  if (!htmlString) return {};
  
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const paragraphs = Array.from(doc.querySelectorAll('p'));
  
  const instructions: any = {};
  let currentHeading = '';
  
  paragraphs.forEach((p) => {
    const strongTag = p.querySelector('strong');
    const text = p.textContent?.trim();
    
    if (strongTag && text) {
      // This is a heading
      currentHeading = text;
      instructions[currentHeading] = [];
    } else if (text && currentHeading) {
      // This is content under a heading
      instructions[currentHeading].push(text);
    }
  });
  
  return instructions;
};

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#FFFFFF',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: 'var(--progress-color, #FBC02D)',
  },
}));

// StartupDashboard component with the new mobile design
const StartupDashboard: React.FC<{
  user: any;
  startupDataCount: any;
  startupData: any;
  meeting: any;
  onCompleteEvaluation: () => void;
  onViewAll: () => void;
  onBeginEvaluation: (startup: any) => void;
  onJoinMeeting: (meeting: any) => void;
}> = ({ user, startupDataCount, startupData, meeting, onCompleteEvaluation, onViewAll, onBeginEvaluation, onJoinMeeting }) => {
  
  return (
    <Box 
      sx={{
        width: '100%',
        maxWidth: '100vw',
        bgcolor: "#ffffff",
        minHeight: "100vh",
        p: 0,
        pb: 6,
        mx: 'auto',
        overflowX: 'hidden',
        boxSizing: 'border-box'
      }}
    >
      {/* Header Section */}
      <Box
        component="div"
        sx={{
          mb: 3
        }}
      >
        <Box display="flex" alignItems="flex-start" gap={2} mb={3}>
          {/* Profile Image - Left Side */}
          <Box
            sx={{
              width: 72,
              height: 72,
              backgroundColor: "#f8f9fa",
              borderRadius: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #e9ecef",
              flexShrink: 0,
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#666666",
                textAlign: "center",
              }}
            >
              {getFirstLetters(user?.applicantName || user?.userName || user?.name || "User")}
            </Typography>
          </Box>

          {/* Content Column - Right Side */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            {/* Name and Welcome Text */}
            <Typography 
              sx={{
                fontFamily: "General Sans",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "140%",
                color: "#333333",
                mb: 0.5
              }}
            >
              Hey {user?.applicantName || user?.userName || user?.name || "User"}
            </Typography>
            <Typography 
              sx={{
                color: "#8A8A8A", 
                fontFamily: "General Sans",
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "140%",
                mb: 2
              }}
            >
              Welcome to the Jury Portal
            </Typography>

            {/* Startups to be Evaluated Section */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography 
                sx={{
                  color: "#333333", 
                  fontFamily: "General Sans",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "140%",
                }}
              >
                Startups to be Evaluated
              </Typography>
              <Typography
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                {String(startupDataCount?.Completed?.length || 0).padStart(2, '0')}/{String(startupDataCount?.Current?.length || 0).padStart(2, '0')}
              </Typography>
            </Box>

            {/* Progress Bar */}
            <Box sx={{ width: '100%' }}>
              <Box
                sx={{
                  width: '100%',
                  height: '6px',
                  backgroundColor: '#FFFFFF',
                  borderRadius: '3px',
                  overflow: 'hidden',
                  border: '1px solid #E5E7EB'
                }}
              >
                <Box
                  sx={{
                    width: (startupDataCount?.Current?.length || 0) > 0 
                      ? `${((startupDataCount?.Completed?.length || 0) / (startupDataCount?.Current?.length || 1)) * 100}%` 
                      : '0%',
                    height: '100%',
                    backgroundColor: (() => {
                      const progress = (startupDataCount?.Current?.length || 0) > 0 
                        ? ((startupDataCount?.Completed?.length || 0) / (startupDataCount?.Current?.length || 1)) * 100 
                        : 0;
                      
                      if (progress === 100) {
                        return '#10B981'; // Green for completed
                      } else if (progress >= 70) {
                        return '#F59E0B'; // Orange for nearly complete
                      } else if (progress >= 30) {
                        return '#FBC02D'; // Yellow for in progress
                      } else {
                        return '#EF4444'; // Red for just started
                      }
                    })(),
                    borderRadius: '3px',
                    transition: 'width 0.3s ease, background-color 0.3s ease'
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Button
          variant="contained"
          size="small"
          sx={{
            alignSelf: "flex-start",
            width: 164,
            height: 36,
            px: 2,
            py: 1,
            borderRadius: "8px",
            background: "linear-gradient(0deg, #604797 0%, #805DC6 100%)",
            color: "#ffffff",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "12px",
            fontFamily: "General Sans",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
              background: "linear-gradient(0deg, #604797 0%, #805DC6 100%)",
            },
          }}
          endIcon={<KeyboardArrowRightIcon sx={{ fontSize: 16 }} />}
          onClick={onCompleteEvaluation}
        >
          Complete Evaluation
        </Button>
      </Box>

      {/* Assigned Startups Section */}
      <Box mb={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography 
            sx={{
              fontFamily: "General Sans",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "140%",
              color: "#333333"
            }}
          >
            Assigned Startups
          </Typography>
          <Button
            variant="text"
            size="small"
            sx={{
              textTransform: "none",
              fontWeight: 500,
              color: "#604797",
              fontSize: "12px",
              fontFamily: "General Sans",
              p: 0,
              minWidth: "auto",
              "&:hover": {
                backgroundColor: "transparent"
              }
            }}
            endIcon={<KeyboardArrowRightIcon sx={{ fontSize: 16 }} />}
            onClick={onViewAll}
          >
            View all
          </Button>
        </Box>

        <Typography 
          sx={{
            color: "#333333",
            fontFamily: "General Sans",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "140%",
            mb: 2
          }}
        >
          {moment().format("dddd, DD MMM")}
        </Typography>

        <Box display="flex" gap={1.5} sx={{ mb: 0, width: '100%', overflowX: 'auto', pb: 1 }}>
          {startupData?.length > 0 ? startupData?.slice(0, 2).map((startup: any, index: number) => (
            <Box key={index} sx={{ flex: 1, minWidth: 0 }}>
              <Box
                sx={{
                  // Was a fixed 160x172 box: the name and sector wrap to two lines on
                  // narrow phones, which pushed the "View Evaluation" row past the fixed
                  // height and clipped it. Size to content and share the row width.
                  width: '100%',
                  height: '100%',
                  minHeight: 172,
                  borderRadius: 1,
                  p: 1.5,
                  backgroundColor: "white",
                  border: "1px solid #E5E7EB",
                  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
                  opacity: 1,
                  display: "flex",
                  flexDirection: "column",
                  transition: "all 0.2s ease-in-out",
                  cursor: "default",
                  "&:hover": {
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    transform: "translateY(-2px)"
                  }
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                {/* Logo Section */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      backgroundColor: "#604797",
                      borderRadius: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#FFFFFF",
                        fontFamily: "General Sans"
                      }}
                    >
                      {getFirstLetters(startup?.Application__r?.Name_of_Product_or_Startup_Venture__c || startup?.Application__r?.Name || "ST")}
                    </Typography>
                  </Box>
                  
                  {/* Video call icon */}
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      backgroundColor: "#604797",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}
                  >
                    <VideocamOutlinedIcon sx={{ fontSize: 10, color: "#FFFFFF" }} />
                  </Box>
                </Box>

                {/* Company Name */}
                <Typography 
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#1F2937",
                    lineHeight: 1.3,
                    mb: 1,
                    fontFamily: "General Sans",
                    display: "block",
                    width: "100%"
                  }}
                >
                  {startup?.Application__r?.Name_of_Product_or_Startup_Venture__c || startup?.Application__r?.Name || "Startup Name"}
                </Typography>

                {/* Sector */}
                <Typography 
                  sx={{
                  color: "#6B7280",
                  fontSize: "12px",
                  fontFamily: "General Sans",
                  fontWeight: 400,
                  mb: 1
                  }}
                >
                  Sector- {startup?.Application__r?.Industry__c || "N/A"}
                </Typography>

                {/* Time */}
                <Box display="flex" alignItems="center" >
                  <AccessTimeOutlinedIcon
                    sx={{ fontSize: 12, color: "#6B7280", marginRight: "4px" }}
                  />
                  <Typography 
                    sx={{
                      color: "#6B7280",
                      fontSize: "12px",
                      fontFamily: "General Sans",
                      fontWeight: 400
                    }}
                  >
                    {startup?.Start_Date_Time__c 
                      ? `${moment(startup.Start_Date_Time__c).format('ha')}, ${moment(startup.Start_Date_Time__c).format('dddd')}` 
                      : `${moment().format('ha')}, ${moment().format('dddd')}`
                    }
                  </Typography>
                </Box>

                {/* Begin Evaluation Button */}
                <Box sx={{ mt: "auto", pt: 1, borderTop: "0.5px solid #D1C8E3" }}>
                  <Button
                    variant="text"
                    size="small"
                    sx={{
                      p: 0,
                      minWidth: "auto",
                      color: "#604797",
                      fontWeight: 500,
                      fontStyle: "Medium",
                      fontSize: "12px",
                      fontFamily: "General Sans",
                      lineHeight: "140%",
                      letterSpacing: "0%",
                      textTransform: "none",
                      textDecoration: "none !important",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "#5B21B6",
                        "& .MuiSvgIcon-root": {
                          transform: "translateX(4px)"
                        }
                      },
                      "& .MuiSvgIcon-root": {
                        transition: "transform 0.2s ease-in-out"
                      }
                    }}
                    endIcon={
                      <KeyboardArrowRightIcon 
                        sx={{ 
                          fontSize: 14, 
                          color: "#604797",
                          ml: 0.5
                        }} 
                      />
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onBeginEvaluation(startup);
                    }}
                  >
                    {startup?.Evaluation_Scores__r?.records?.[0]?.Evaluated__c ? "View Evaluation" : "Begin Evaluation"}
                  </Button>
                </Box>
              </Box>
            </Box>
          )) : (
            <Box
              sx={{
                borderRadius: 2,
                p: 3,
                backgroundColor: "#ffffff",
                border: "1px solid #e5e7eb",
                textAlign: "center",
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
                width: "100%"
              }}
            >
              <Typography color="text.secondary" fontSize="0.875rem">
                No startups assigned yet
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Today's Events Section */}
      <Box>
        <Box display="flex" alignItems="center" mb={2}>
          <Box sx={{ width: 4, height: 20, bgcolor: "#9333ea", borderRadius: 1, mr: 1 }} />
            <Typography 
            sx={{
              fontFamily: "General Sans",
              fontWeight: 500,
              fontStyle: "Medium",
              fontSize: "12px",
              lineHeight: "140%",
              letterSpacing: "0%",
              color: "#333333"
            }}
            >
            Today, {moment().format("DD MMM YYYY")}
            </Typography>
        </Box>

        <Typography color="text.secondary" fontSize="0.875rem" mb={2}>
          {meeting?.length || 0} Events
        </Typography>

        <Box display="flex" flexDirection="column" gap={1.5} sx={{ pb: 4 }}>
          {meeting?.length > 0 ? meeting?.slice(0, 2).map((event: any, index: number) => (
            <Box
              key={index}
              sx={{
                borderRadius: 2,
                p: 2,
                bgcolor: "#f5f3ff",
                border: "1px solid #ede9fe",
                minHeight: "fit-content",
                cursor: event?.Meeting_Link__c ? "pointer" : "default",
              }}
              onClick={() => {
                if (event?.Meeting_Link__c) {
                  onJoinMeeting(event);
                }
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                <Box flex={1}>
                  <Typography fontWeight={600} fontSize="0.875rem" mb={0.5}>
                    {event?.Application__r?.Name || event?.Name || "Meeting"} - Evaluation call
                  </Typography>
                  <Typography 
                    color="text.secondary" 
                    fontSize="0.75rem" 
                    mb={1}
                    sx={{
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      lineHeight: 1.3
                    }}
                  >
                    {event?.Application__r?.Description__c || event?.Description__c || "Evaluation meeting with startup"}
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <AccessTimeOutlinedIcon
                      sx={{ fontSize: 14, color: "#6b7280", marginRight: "6px" }}
                    />
                    <Typography color="text.secondary" fontSize="0.75rem">
                      {event?.Start_Date_Time__c && event?.End_Date_Time__c 
                        ? `${moment(event.Start_Date_Time__c).format('hh:mm A')} - ${moment(event.End_Date_Time__c).format('hh:mm A')}`
                        : "Time TBD"
                      }
                    </Typography>
                  </Box>
                </Box>
                <IconButton
                  sx={{
                    bgcolor: "#9333ea",
                    color: "white",
                    "&:hover": { bgcolor: "#7e22ce" },
                    ml: 1,
                    width: 36,
                    height: 36,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onJoinMeeting(event);
                  }}
                  disabled={!event?.Meeting_Link__c}
                >
                  <VideocamOutlinedIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Box>
            </Box>
          )) : (
            <Box
              sx={{
                borderRadius: 2,
                p: 3,
                bgcolor: "#ffffff",
                border: "1px solid #e9ecef",
                textAlign: "center",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              }}
            >
              <Typography color="text.secondary" fontSize="0.875rem">
                No events scheduled for today
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const DashBoard: React.FunctionComponent = () => {
  dayjs.extend(utc);
  const navigate = useHistory();
  const classes = useStyles();
  const [contactId, setContactId] = useState<string | null>(null);
  const [user, setUser] = useState<any>(null);
  const isMobile = useMediaQuery('(max-width:600px)');
  const isMaxScreen = useMediaQuery('(min-width:1920px)');
  const is1440 = useMediaQuery('(max-width:1440px)');
  const [open, setOpen] = useState<boolean>(false);
  const [meeting, setMeeting] = useState<any>([]);
  const [startupData, setStartupData] = useState<any>([]);
  const [selectedDate, setSelectedDate] = useState<any>(moment());
  const [loader, setLoader] = useState<boolean>(false);
  const [meetingDates, setMeetingDates] = useState<Array<any>>([]);
  const [instructions, setInstructions] = useState<any>({});

  // Load storage data on component mount
  useEffect(() => {
    const loadStorageData = async () => {
      try {
        const contactIdData = await storageService.getItem('contactId');
        setContactId(contactIdData);
        
        const userData = await storageService.getItem('user');
        if (userData) {
          setUser(typeof userData === 'string' ? JSON.parse(userData) : userData);
        }
      } catch (error) {
        console.error('Error loading storage data:', error);
      }
    };
    loadStorageData();
  }, []);

  // Fetch instructions
  useEffect(() => {
    getInstructions().then((res: any) => {
      console.log("Full API Response:", res);
      console.log("Response data:", res?.data);
      const htmlContent = res?.data?.[0]?.Description_Rich_Text__c;
      console.log("HTML Content:", htmlContent);
      if (htmlContent) {
        const parsedInstructions = parseInstructions(htmlContent);
        console.log("Parsed Instructions:", parsedInstructions);
        console.log("Number of instruction sections:", Object.keys(parsedInstructions).length);
        setInstructions(parsedInstructions);
      } else {
        console.warn("No Instruction__c field found in response");
      }
    }).catch((error) => {
      console.error("Error fetching instructions:", error);
    });
  }, []);

  const [startupDataCount, setStartupDataCount] = useState<any>({
    Current: [],
    Completed: [],
    InComplete: [],
  });

  const handleModalClose = () => {
    setOpen(!open);
  };

  const handleGoto = (link: string) => {
    window.open(link, '_blank');
  };

  function ServerDay(props: PickersDayProps<Moment>) {
    const { day, outsideCurrentMonth, selected, ...other } = props;
    const past = moment().format('YYYY-MM-DD') > moment(day).format('YYYY-MM-DD');
    const isMeetingSelected =
      meetingDates.filter((items: any) => {
        return items === moment(day).format('YYYY-MM-DD');
      }).length > 0;

    return (
      <PickersDay
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          fontFamily: '"General Sans", sans-serif',
          background: isMeetingSelected ? '#D9C8FF' : selected ? '#604797' : 'transparent',
          color: isMeetingSelected ? '#091E42' : selected ? '#fff' : '#373737',
          ':disabled': {
            background: past ? 'transparent' : '#E6E6E6',
            color: past ? '#B0B0B0' : '#8A8A8A',
          },
          ':focus': {
            background: '#604797',
            color: '#fff',
          },
          ':hover': {
            color: 'black',
          },
        }}
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        disabled={past}
      />
    );
  }

  useEffect(() => {
    // if (!contactId) {
    //   return;
    // }
    if (!user?.accountId) {
      return;
    }
    setLoader(true);
    getMeetings(user.accountId)
      .then((response) => {
        const currentDate = new Date();
        const assignments = response?.data?.data?.assignments || [];
        const meetings = response?.data?.data?.meetings || [];
        const upcomingMeetings = meetings.filter((meeting: any) => {
          const startDate: any = new Date(meeting.End_Date_Time__c);
          return startDate >= currentDate;
        });
        let customAssignment = [];

        for (let i = 0; i < assignments.length; i++) {
          const element = assignments[i];
          const getMeeting = upcomingMeetings.find((items: any) => {
            return items?.Application__c === element?.Application__c;
          });
          customAssignment.push({ ...element, ...getMeeting });
        }

        const customData = {
          Current: [] as any[],
          Completed: [] as any[],
          InComplete: [] as any[],
        };
        for (let i = 0; i < customAssignment.length; i++) {
          const element = customAssignment[i];

          if (element?.Evaluation_Scores__r?.records?.[0]?.Evaluated__c === true) {
            customData['Completed'].push(element);
          } else {
            customData['InComplete'].push(element);
          }
          customData['Current'].push(element);
        }

        setStartupDataCount(customData);
        setStartupData(customAssignment);

        if (meetings) {
          const selectedDates = [];

          const sortedMeetings = upcomingMeetings
            .map((meetingItem: any) => {
              const matchedAssignment = assignments.find((a: any) => a?.Application__c === meetingItem?.Application__c);
              return {
                ...meetingItem,
                startupName: matchedAssignment?.Application__r?.Name_of_Product_or_Startup_Venture__c || meetingItem?.Name,
              };
            })
            .sort((a: any, b: any) => {
              const startDateA: any = new Date(a.End_Date_Time__c);
              const startDateB: any = new Date(b.End_Date_Time__c);
              return startDateA - startDateB;
            });

          for (let i = 0; i < sortedMeetings.length; i++) {
            const element = sortedMeetings[i];
            selectedDates.push(moment(element?.Start_Date_Time__c).format('YYYY-MM-DD'));
          }
          setMeeting(sortedMeetings);
          setMeetingDates(selectedDates);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  }, [user]);

  return (
    <>
      {loader && <Loaders />}
      <Dialog
        open={open}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: isMobile ? '8px' : isMaxScreen ? '12px' : '10px',
            minWidth: isMobile ? '328px' : isMaxScreen ? '1148px' : '852px',
          },
        }}
        onClose={handleModalClose}
      >
        <Box component="div" maxWidth={'100%'} sx={{ border: 'none', outline: 'none', borderRadius: '10px' }}>
          <Box component={'div'} className={`d-flex justify-content-between align-items-center ${classes.instructionHeadContainer}`}>
            <Typography className={classes.instructionHead}>Instruction</Typography>
            <IconButton onClick={handleModalClose}>
              <RxCross1 color={isMobile ? '#545454' : '#6A4EA6'} size={'16px'} />
            </IconButton>
          </Box>
          <Box component={'div'} padding={isMobile ? '16px' : '24px 40px'} className="d-flex flex-column" gap={isMobile ? '16px' : '24px'}>
            {Object.keys(instructions).length > 0 ? (
              Object.keys(instructions).map((items: string, index: number) => {
                return (
                  <Box component={'div'} className="d-flex flex-column" gap={'2px'} key={index}>
                    <Typography className={classes.instructionsHeading}>{items}</Typography>
                    {instructions[items].map((content: string, subIndex: number) => {
                      return (
                        <Typography key={subIndex} className={classes.instructionsContext}>
                          {content}
                        </Typography>
                      );
                    })}
                  </Box>
                );
              })
            ) : (
              <Box component={'div'} sx={{ textAlign: 'center', py: 4 }}>
                <Typography sx={{ color: '#666', fontSize: '14px' }}>
                  Loading instructions...
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Dialog>

      {/* Conditional rendering based on screen size */}
      {isMobile ? (
        <Box 
          sx={{
            height: '100vh',
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            bgcolor: '#ffffff',
            display: 'flex',
            justifyContent: 'center',
            overscrollBehavior: 'contain',
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            touchAction: 'pan-y',
            position: 'relative'
          }}
        >
          <StartupDashboard
            user={user}
            startupDataCount={startupDataCount}
            startupData={startupData}
            meeting={meeting}
            onCompleteEvaluation={async () => {
              const items = startupDataCount?.InComplete?.[0];
              if (items) {
                await storageService.setItem('PanelId', items?.Id);
                navigate.push(`/startup-profile/${items?.Application__c}`, { 
                  startupHeader: items?.Application__r, 
                  isEvaluated: items?.Evaluation_Scores__r?.records?.[0]?.Evaluated__c,
                  tabState: 3
                });
              }
            }}
            onViewAll={() => {
              navigate.push(routes.allStartup);
            }}
            onBeginEvaluation={async (startup: any) => {
              if (startup) {
                await storageService.setItem('PanelId', startup?.Id);
                navigate.push(`/startup-profile/${startup?.Application__c}`, { 
                  startupHeader: startup?.Application__r, 
                  isEvaluated: startup?.Evaluation_Scores__r?.records?.[0]?.Evaluated__c,
                  tabState: 3
                });
              }
            }}
            onJoinMeeting={(meeting: any) => {
              handleGoto(meeting?.Meeting_Link__c);
            }}
          />
        </Box>
      ) : (
        <AppLayout>
          <Grid container spacing={2} alignItems={'stretch'}>
            <Grid item lg={3.2} md={12}>
              <Box component={'div'} className={`d-flex flex-column justify-content-between ${classes.welcomContainer}`}>
                <Box component={'div'} className="d-flex align-items-center" gap={isMobile ? '8px' : '10px'} style={{ display: "flex" }}>
                  <Box component={'div'} className={`d-flex justify-content-center align-items-center ${classes.avatarContainer}`} style={{ flexShrink: 0 }}>
                    <Typography className={classes.avatarText}>{getFirstLetters(user?.userName)}</Typography>
                  </Box>
                  <Box component={'div'} className="d-flex flex-column" gap={'5px'} mt={3.5}>
                    <Typography className={classes.welcomCardName} color={'#FFFFFF'}>
                      Hey {user?.userName}
                    </Typography>
                    <Typography className={classes.welcomeCardDescp} color={'#FFFFFF'}>
                      Welcome to the Jury Portal 👋🏻
                    </Typography>
                  </Box>
                </Box>
                <Box component={'div'} className="d-flex flex-column" gap={'8px'}>
                  <Box component={'div'} className="d-flex justify-content-between align-items-center" mt={3}>
                    <Typography className={classes.teamEval} color={'#fff'}>
                      Teams to be Evaluated
                    </Typography>
                    <Typography className={classes.teamEval} color={'#fff'}>
                      {startupDataCount?.Completed?.length || 0}/{startupDataCount?.Current?.length || 0}
                    </Typography>
                  </Box>
                  <BorderLinearProgress 
                    variant="determinate" 
                    value={(startupDataCount?.Current?.length || 0) > 0 ? ((startupDataCount?.Completed?.length || 0) / (startupDataCount?.Current?.length || 1)) * 100 : 0} 
                    sx={{
                      [`& .${linearProgressClasses.bar}`]: {
                        backgroundColor: (() => {
                          const progress = (startupDataCount?.Current?.length || 0) > 0 
                            ? ((startupDataCount?.Completed?.length || 0) / (startupDataCount?.Current?.length || 1)) * 100 
                            : 0;
                          
                          if (progress === 100) {
                            return '#10B981'; // Green for completed
                          } else if (progress >= 70) {
                            return '#F59E0B'; // Orange for nearly complete
                          } else if (progress >= 30) {
                            return '#FBC02D'; // Yellow for in progress
                          } else {
                            return '#EF4444'; // Red for just started
                          }
                        })(),
                      },
                    }}
                  />
                </Box>
                <Button
                  variant="contained"
                  style={{ marginTop: 30, width: "55%", color: "#333333", backgroundColor: "white", fontSize: 12 }}
                  endIcon={<KeyboardArrowRightIcon sx={{ color: '#333333' }} />}
                  disabled={(startupDataCount?.Completed?.length || 0) === (startupDataCount?.Current?.length || 0) || (startupDataCount?.Current?.length || 0) === 0}
                  onClick={async () => {
                    const items = startupDataCount?.InComplete?.[0];
                    if (items) {
                      await storageService.setItem('PanelId', items?.Id);
                      navigate.push(`/startup-profile/${items?.Application__c}`, { 
                        startupHeader: items?.Application__r, 
                        isEvaluated: items?.Evaluation_Scores__r?.records?.[0]?.Evaluated__c,
                        tabState: 3
                      });
                    }
                  }}
                >
                  Complete evaluation
                </Button>
              </Box>
            </Grid>
            <Grid item lg={2} md={12}>
              <Box component={'div'} className={`d-flex flex-column justify-content-end w-100 ${classes.instructionTab}`}>
                <Box component={'img'} src={net} className={classes.instructionTabBg} />
                <Box component={'img'} src={gradient} className={classes.instructionTabBg} />
                <Box component={'div'} className="d-flex flex-column" gap={isMobile ? '2px' : '18px'} padding={'14px'}>
                  <Box component={'div'} className="d-flex flex-column" gap={'6px'}
                    style={{ marginTop: "90%", zIndex: 99 }}>
                    <Typography component={'h6'} className={classes.instructionCardTitle} color={'#FFFFFF'}>
                      Read the Instruction
                    </Typography>
                    <Typography component={'h6'} className={classes.instructionCardDescp} color={'#FFFFFF91'}>
                      Please read the below instructions
                    </Typography>
                  </Box>
                  <Button
                    style={{ marginTop: "10px" }}
                    variant="contained"
                    endIcon={<KeyboardArrowRightIcon sx={{ color: '#333333' }} />}
                    className={classes.instructionButton}
                    onClick={() => {
                      handleModalClose();
                    }}
                  >
                    View instruction
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={5.5} md={12}>
              <Box component={'div'} className={`d-flex ${classes.scheduleSection}`} gap={'15px'} style={{ height: "33vh", display: "flex", width: "81%" }}>
                <Box>
                  <DateCalendar
                    slots={{
                      day: ServerDay,
                    }}
                    views={['day']}
                    classes={{ root: classes.rootClasses }}
                    minDate={moment().startOf('date')}
                    value={selectedDate}
                    sx={{
                      width: '100%',
                      '& .MuiDayCalendar-monthContainer': {
                        height: '12rem !important', // Reduced height
                        overflowY: 'scroll', // Enable scrolling
                        scrollbarWidth: 'inherit !important', // For Firefox
                        '&::-webkit-scrollbar': {
                          width: '4px', // Scrollbar width
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: 'rgba(0, 0, 0, 0.3)', // Scrollbar color
                          borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Hover effect
                        },
                      },
                    }}
                    onChange={(value: any) => {
                      setSelectedDate(value);
                    }}
                  />
                </Box>
                <Box component={'div'} className="d-flex flex-column w-100" gap={'12px'} mt={1}>
                  <Typography className={classes.scheduleTitle} color={'#373A45'}>
                    Your schedule
                  </Typography>
                  <Box component={'div'} className="d-flex align-items-center" gap={'8px'}>
                    <Box component={'div'} className="d-flex align-items-center" gap={'4px'}>
                      <Box
                        component={'div'}
                        sx={{
                          height: '18px',
                          width: '4px',
                          background: '#A23770',
                        }}
                      />
                      <Box
                        component={'div'}
                        sx={{
                          height: '18px',
                          width: '4px',
                          background: '#E4AF29',
                        }}
                      />
                    </Box>
                    <Typography fontWeight={'500'} fontSize={'12px'} color={'#333333'}>
                      {meeting.length} Events
                    </Typography>
                  </Box>
                  <Box component={'div'} className={`d-flex flex-column ${classes.startupSection}`}>
                    {meeting.map((items: any, index: number) => {
                      return (
                        <Box component={'div'} key={index} className={`d-flex align-items-start justify-content-between w-100 ${classes.startUpSectionContainer}`}>
                          <Box component={'div'} className="d-flex flex-column" gap={'6px'} maxWidth={isMaxScreen ? '269px' : '170px'}>
                            <Typography color={'#000000'} className={classes.scheduleTitleHead}>
                              {items?.Name}
                            </Typography>
                            {items?.startupName && items?.startupName !== items?.Name && (
                              <Typography color={'#585A64'} className={classes.scheduleVenue}>
                                Startup: {items?.startupName}
                              </Typography>
                            )}
                            <Typography color={'#000000'} className={classes.scheduleVenue}>
                              Venue: Turbostart Bangalore
                            </Typography>
                            <Box component={'div'} gap={'4px'} className="d-flex align-items-center">
                              <AccessTimeOutlinedIcon sx={{ height: '16px', width: '16px' }} />
                              <Typography className={classes.scheduleDuration} color={'#373A45'}>
                                {moment(items?.Start_Date_Time__c).format('Do MMM YYYY, hh:mm A')} - {moment(items?.End_Date_Time__c).format('hh:mm A')}
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            component={'div'}
                            gap={'12px'}
                            className="d-flex align-items-center"
                            onClick={() => {
                              handleGoto(items?.Meeting_Link__c);
                            }}
                          >
                            <Typography className={classes.scheduleDuration} color={'#585A64'}>
                              Join Meeting
                            </Typography>
                            <Box component={'div'} className={`d-flex justify-content-center align-items-center ${classes.videoCamBg}`}>
                              <VideocamOutlinedIcon sx={{ height: '14px', color: '#F6F8FB' }} />
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box component={'div'} className={classes.assignedStartupsection}>
            {/* Header Section */}
            <Box
              component={'div'}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              margin={'10px 0px'}
            >
              {/* Left: Assigned Startups */}
              <Typography
                className={classes.assignedStartupHeader}
                color={'#333333'}
                width={isMobile ? '60%' : '100%'}
              >
                Assigned Startups
              </Typography>

              {/* Right: View All */}
              <Typography
                className={classes.assignedStartupHeaderBtn}
                color={'#333333'}
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  navigate.push(routes.allStartup);
                }}
              >
                {'View all'}
                <KeyboardArrowRightIcon
                  sx={{ height: '20px', color: '#333333', marginLeft: '4px' }}
                />
              </Typography>
            </Box>

            {/* Divider */}
            <Divider
              sx={{
                margin: isMaxScreen ? '30px 0px' : '10px 0px',
                marginBottom: 2,
              }}
            />

            {/* Startup Table */}
            <StartupTable 
              data={startupData.slice(0, 3) || []}
              showPagination={false}
            />
          </Box>
        </AppLayout>
      )}
    </>
  );
};

export default DashBoard;
